var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDisclosures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 139.5,
    stroke: "#EBFAF2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 109.5,
    stroke: "#D7F5E4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 79.5,
    stroke: "#AFECC9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 49.5,
    stroke: "#87E2AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 126.667H132C131.293 126.667 130.614 126.948 130.114 127.448C129.614 127.948 129.333 128.626 129.333 129.333V150.667C129.333 151.374 129.614 152.052 130.114 152.552C130.614 153.052 131.293 153.333 132 153.333H148C148.707 153.333 149.385 153.052 149.886 152.552C150.386 152.052 150.667 151.374 150.667 150.667V134.667L142.667 126.667Z",
    stroke: "#054A41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 126.667V134.667H150.667",
    stroke: "#054A41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.333 141.333H134.667",
    stroke: "#054A41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.333 146.667H134.667",
    stroke: "#054A41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.333 136H136H134.667",
    stroke: "#054A41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDisclosures);
export default __webpack_public_path__ + "static/media/empty-disclosures.4f21cffe0243b4d4b762f85146bc4d0d.svg";
export { ForwardRef as ReactComponent };